import React, { useEffect, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal, ModalBody } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';
import { useRef } from 'react';

const StatusData = [
  { display: 'Active', value: 'Active' },
  { display: 'InActive', value: 'InActive' },
];
const AddNewHealthConcern = (props) => {
  let { patientID, IsEditAllowed } = props;
  // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
  const { isOpenHealthConcern, onClose, onDeleteHealthConcern } = { ...props }
  const API_URL = enumUtil.controller.General
  let HealthConcern_Modal = {
    Notes: "",
    // HealthConcernSearch: "",
    // OnsetDate: "",
    // Status: "",
  }
  let valModal = {}
  let ValidationModal = {
    // HealthConcernSearchVal: "",
    NotesVal: "",
    // StatusVal: "",
  }
  const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
  const [healthConcernID, setHealthConcernID] = useState();
  console.log("propsAddNewHealthConcern", props, healthConcernID)
  const [healthConcernValidationModal, setHealthConcernValidationModal] = useState(ValidationModal)
  const [healthConcernSaveUpdateModal, setHealthConcernSaveUpdateModal] = useState({})
  const [mainHealthConcernModal, setMainHealthConcernModal] = useState(HealthConcern_Modal);
  const [isLoading, setIsLoading] = useState(false)
  const [onHealthConcernSaved, setOnHealthConcernSaved] = useState(false)
  const [del, setDel] = useState(false)
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [is, setIs] = useState(false);
  console.log("AddNewProblem", props)

  useEffect(() => {
    // setPracticeID(PracticeID)
    if (props.healthConcernID != null) {
      setDel(true)
      setHealthConcernID(props.healthConcernID)
    } else {
      if (!onHealthConcernSaved) {
        setHealthConcernID(0);
        setDel(false)
      } else {
        setDel(true)
      }
    }
    if (!isNull(healthConcernID)) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "ID": healthConcernID,
        "TableName": enumUtil.enumAPITableName.HealthConcern
      }).then((response) => {
        setIsLoading(false);
        setMainHealthConcernModal(response);
      }).catch((error) => {
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        setIsLoading(false)
      })
    }
  }, [healthConcernID])

  const HealthConcernValidation = async () => {
    let ValidationModal = {
      NotesVal: FormValidator(
        mainHealthConcernModal.Notes,
        enumUtil.enumValidationType.Required,
        'Notes',
      ),
      // StatusVal: FormValidator(
      //     mainHealthConcernModal.Status,
      //     enumUtil.enumValidationType.Required,
      //     'Status',
      // ),

    }
    await setHealthConcernValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  const handleSaveHealthConcern = async () => {
    if(!IsEditAllowed) return;
    await HealthConcernValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      setHealthConcernSaveUpdateModal(healthConcernSaveUpdateModal)
      let saveModal = {
        TableName: enumUtil.enumAPITableName.HealthConcern,
        ID: healthConcernID,
        data: { PatientID: patientID, ...healthConcernSaveUpdateModal },
        value: null
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
            props.setIsRecordSaved(true);
            // setHealthConcernID(response.id)
            // setOnHealthConcernSaved(true)
            onClose()
          }
        }).catch((error) => {
          setIsLoading(false)
          console.log('error', error);
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
  }

  const handleClear = () => {
    setMainHealthConcernModal(HealthConcern_Modal);
    setHealthConcernSaveUpdateModal({});
  }
  const handleChange = (e) => {
    let { name, value } = e.target
    let modal = { ...mainHealthConcernModal };
    let saveModal = { ...healthConcernSaveUpdateModal }
    modal[name] = value
    setMainHealthConcernModal(modal)
    for (var property in HealthConcern_Modal) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setHealthConcernSaveUpdateModal(saveModal)
  }
  // const handleDateChange = (date, type) => {
  //   var FormatedDate = date
  //   let modal = { ...mainHealthConcernModal };
  //   let saveModal = { ...healthConcernSaveUpdateModal }
  //   modal[type] = FormatedDate
  //   setMainHealthConcernModal(modal)
  //   for (var property in HealthConcern_Modal) {
  //     if (type === property) {
  //       saveModal[type] = FormatedDate
  //     }
  //   }
  //   setHealthConcernSaveUpdateModal(saveModal)
  // }

  const HealthConcernName = () => {
    return (
      <p className="heading">Health Concern</p>
    )
  }
  // const handleSelectedData = (selectedData, name, type, mode) => {
  //   setIs(true)
  //   let modal = { ...mainHealthConcernModal };
  //   if (type === 'client' && !isNull(selectedData)) {
  //       if (name === "Status") {
  //           modal[name] = selectedData.display
  //           healthConcernSaveUpdateModal[name] = selectedData.value + "";
  //           // setProviderID(selectedData.value + "")
  //       } else if (name === "ProviderID") {
  //           modal[name] = selectedData.display
  //           healthConcernSaveUpdateModal[name] = selectedData.value + "";
  //           // setProviderID(selectedData.value + "")
  //       }
  //   } else if (type === 'server' && !isNull(selectedData)) {
  //       // if (name === 'POSCode') {
  //       //     LocationSaveUpdateModal[name] = selectedData.ID
  //       //     setPOS(selectedData.ID)


  //   } else {

  //       modal[name] = ''
  //       healthConcernSaveUpdateModal[name] = ''
  //   }
  //   setMainHealthConcernModal(modal)
  //   return selectedData
  // }


  const handleDeleteModal = () => {
    setisOpenDeleteAlert(true)
  }
  const onCloseDelete = () => {
    setisOpenDeleteAlert(false);
  }
  const onDelete = () => {
    props.setIsRecordSaved(true);
    setisOpenDeleteAlert(false);
    onClose();
  }

  let DeleteConfirmation = "";
  if (isOpenDeleteAlert) {
    DeleteConfirmation = (
      <DeleteConfirmatiom
        isOpenAlert={isOpenDeleteAlert}
        hideReason={true}
        API_URL={API_URL}
        TableName={enumUtil.enumAPITableName.HealthConcern}
        ID={healthConcernID}
        onCloseDelete={onCloseDelete}
        onClose={onDelete}
      />
    );
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = (
      <button
        className={
          props?.IsDeleteAllowed
            ? 
          "btn-icon-transparent"
            : 
            "btn-icon-transparent delete-btn-disabled"
        } onClick={handleDeleteModal}>
        <span className="icon"><i className="icon-delete"></i></span>
        <span className="title">Delete</span>
      </button>
    );
  }
  const textareaRef = useRef(null);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.setProperty('height', 'auto', 'important');
      textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
    }
  };
  useEffect(() => {
    adjustTextareaHeight();
  }, [mainHealthConcernModal.Notes]);
  return (
    <Modal show={isOpenHealthConcern} onHide={isOpenHealthConcern} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
      <Modal.Body>
        {DeleteConfirmation}
        {isLoading && <Loader />}
        {/* <ModalHeader HeaderName={HealthConcernName} DeletePopup={''} isClosed={onClose} /> */}
        <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={HealthConcernName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
        <div className="">
          <div className={`input my-2 ${healthConcernValidationModal.NotesVal ? 'error' : ''}`}>
            {/* <label className="pb-3px">Notes</label> */}
            <textarea
              rows="3"
              name="Notes"
              id="Notes"
              className="form-control overflow-hidden"
              ref={textareaRef}
              onInput={adjustTextareaHeight}
              value={mainHealthConcernModal.Notes}
              onChange={handleChange}
            ></textarea>
            {healthConcernValidationModal.NotesVal}
          </div>
          {/* <div className="input my-2">
                <div className='input-group hk-input-search'>
                    <input 
                      type="text" 
                      className='form-control'
                      placeholder='Search existing problems or allergies  here...'
                      id="HealthConcernSearch"
                      name="HealthConcernSearch"
                      value={mainHealthConcernModal.HealthConcernSearch}
                      onChange={handleChange}
                    />
                    <span className="input-group-text seraches" id="basic-addon2">
                        <i className="bi bi-search"></i>
                    </span>
                </div>
            </div>
                {mainHealthConcernModal.HealthConcernSearch &&
                <div className="blue-bg-header mb-2">
                    <p className="heading text-white">{mainHealthConcernModal.HealthConcernSearch}</p>
                </div>}
            <div className="d-flex align-items-end gap-12 mb-12">
                <div className={`${healthConcernValidationModal.OnsetDateVal ? "error" : ""} input mb-0`}>
                    <label className="pb-3px">Onset Date</label>
                      <DatePicker 
                      className='mb-0'
                      value={mainHealthConcernModal.OnsetDate}
                      handleCalendarChangefunc={date => handleDateChange(date,'OnsetDate')} />
                      {healthConcernValidationModal.OnsetDateVal}
                </div>
                {/* <div className="form-group input">
                <div className="form-group input">
                    <div className={`input form-group ar-multiple-br m-0 ${healthConcernValidationModal.StatusVal ? "error" : ""}`}>
                        <label className="pb-3px">Status</label>
                        <SuperSearchList
                              type="client"
                              id='Status'
                              name='Status'
                              searchValue={mainHealthConcernModal.Status}
                              data={StatusData}
                              onChange={handleChange}
                              getSelectedData={handleSelectedData}
                              is={is}
                              sup_btn='sup_btn-Inp'
                              sup_inp='superSearchVisitInp'
                              placeholder="Select type..."
                              inputError={healthConcernValidationModal.StatusVal}
                          />
                        {healthConcernValidationModal.StatusVal}
                    </div>
                </div>
            </div> */}
        </div>
      </Modal.Body>
      <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
        <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveHealthConcern}>Save</button>
      </div>
    </Modal>
  )
}

export default AddNewHealthConcern